import React, { FC, ReactElement } from 'react';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Modal } from 'react-bootstrap';
import { Box, Button } from '@qwealth/qcore';
import { DemographicForm, DemographicInternalForm, demographicValidator } from '@qwealth/kyc';

interface Props {
  shouldShowModal: boolean;
  onClose: () => void;
  initialValues: DemographicForm;
  updateFormValues: (values: any) => void;
}

const EditDemographic: FC<Props> = ({
  shouldShowModal,
  onClose,
  initialValues,
  updateFormValues
}): ReactElement => {
  const submitHandler = async (values) => {
    await updateFormValues(values);
    onClose();
  };
  return (
    <Form
      validate={(values) => demographicValidator(values).result}
      onSubmit={submitHandler}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators
      }}
      render={({
        handleSubmit,
        dirty,
        form: {
          mutators: { togglePrimaryEmail, togglePrimaryPhone }
        },
        errors,
        touched
      }) => (
        <Modal onHide={onClose} show={shouldShowModal} size="xl">
          <Modal.Header closeButton>
            <Box textStyle="sectionTitle">Edit Demographic Information</Box>
          </Modal.Header>
          <Modal.Body>
            <DemographicInternalForm
              isDirty={dirty}
              editing
              isAnnualReview
              togglePrimaryEmailMutator={togglePrimaryEmail}
              togglePrimaryPhoneMutator={togglePrimaryPhone}
              errors={errors}
              touched={touched}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" onClick={handleSubmit}>
              Update
            </Button>
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    />
  );
};

export default EditDemographic;
